export const ContextSelectorStyles = {
  width: 110,
};